import React from 'react';
import PropType from 'prop-types';
import BasicAvatar from 'react-user-avatar';
import cn from 'classnames';

import styles from './Avatar.scss';

const colors = ['#e67e22', '#2ecc71', '#3498db', '#8e44ad', '#e74c3c', '#1abc9c', '#2c3e50'];

Avatar.propTypes = {
    className: PropType.string,
    name: PropType.string.isRequired,
    src: PropType.string,
    size: PropType.number,
    fontSize: PropType.number,
};

Avatar.defaultProps = {
    size: 36,
};

export default function Avatar({ className, name, src, size, fontSize }) {
    if (!fontSize) {
        fontSize = Math.round(size * 0.3888);
    }

    const normalName = name
        .split(' ')
        .slice(0, 2)
        .join(' ');

    return (
        <BasicAvatar
            className={cn(styles.root, className)}
            style={{ fontSize }}
            size={size}
            name={normalName}
            src={src}
            title={name}
            colors={colors}
        />
    );
}
